import React from "react";
import "./styles.scss";
import { browse, browseableKeys } from "../../../../api/discover";
import { log_error } from "../../../../api";
import FullPageSpinner from "../../../FullPageSpinner";
import _ from "lodash";
import ResultComponent from "./ResultComponent";
import { indexPosts } from "../../../../api/posts";
import PostsList from "../../PostsList";

const postsFilters = [
  { id: 1, text: "all" },
  { id: 2, key: "attachment_type", text: "audio", value: "SoundTrack" },
  { id: 3, key: "attachment_type", text: "video", value: "Video" },
  { id: 4, key: "attachment_type", text: "picture", value: "Image" },
];

export default class extends React.Component {
  state = { results: {}, posts: [], posts_loading: false, searching: false };
  componentDidMount = async () => {
    this.updateResults();
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.query !== this.props.query) {
      this.updateResults();
    }
  };

  searchResults = params => {
    return browse(params);
  };

  updateResults = async () => {
    try {
      this.setState({ results: {}, posts: [], searching: true });
      const requestParams = [
        { query: this.props.query, ...browseableKeys.songs },
        { query: this.props.query, ...browseableKeys.artists },
        { query: this.props.query, ...browseableKeys.profiles },
        { query: this.props.query, ...browseableKeys.albums },
        { query: this.props.query, ...browseableKeys.playlists },
      ];
      const searchPromises = [];
      requestParams.forEach(params => {
        searchPromises.push(this.searchResults(params));
      });
      const searchResults = await Promise.all(searchPromises);
      this.setState({searching: false});
      searchResults.forEach(result => {
        const { results } = result.data;
        const type = Object.keys(results)[0];
        const updates = {};
        updates[type] = results[type];
        this.setState((prevState) => ({ results: { ...prevState.results, ...updates } }));
      });
      let {
        data: { posts },
      } = await indexPosts({ filter: { query: this.props.query } });
      this.setState({ posts });
    } catch (error) {
      console.log(log_error(error));
    }
  };
  handlePostsFillters = async (filter) => {
    console.log("filter", filter);
    this.setState({ posts: undefined, posts_loading: true });
    let {
      data: { posts },
    } = await indexPosts({ filter: filter });
    this.setState({ posts: posts, posts_loading: false });
  };
  renderResult = (object) => {};

  postsSetter = (newPost) => {
    this.setState({
      posts: this.state.posts.map((post) =>
        newPost.id === post.id ? newPost : post
      ),
    });
  };

  render() {
    const { results: {artists = [], profiles = [], albums = [], songs = [], playlists = []}, searching, posts_loading, posts = [] } = this.state;
    if (searching || posts_loading) return <FullPageSpinner />;

    const resultsEmpty = !searching && !artists.length && !profiles.length && !albums.length && !songs.length && !playlists.length;
    const postsEmpty = !posts_loading && !posts.length;

    if (resultsEmpty && postsEmpty) {
      return (
        <h2 className="text-primary text-center">
        Oops! We couldn't find anything matching your search. Try again?
      </h2>
      )
    }
     
    return (
      <div id="browse-results" className="row my-3">
        <div className="col-100 ">
          <h1>Search Results</h1>
        </div>
        {artists.length > 0  && <ResultComponent
          id="artists"
          className="col-50 my-2"
          label="artists"
          items={artists}
        />}
        {profiles.length > 0 && <ResultComponent
          id="profiles"
          className="col-50 my-2"
          label="profiles"
          items={profiles}
        />}
        {songs.length > 0 && <ResultComponent
          id="songs"
          className="col-100 my-2"
          label="songs"
          items={songs}
        />}
        {albums.length > 0 && <ResultComponent
          id="albums"
          className="col-50 my-2"
          label="albums"
          items={albums}
        />}
        {playlists.length > 0 && <ResultComponent
          id="playlists"
          className="col-50 my-2"
          label="playlists"
          items={playlists}
        />}
        {posts.length > 0 && 
          <div className="col-100">
          <h2 className="label text-uppercase text-muted mt-4"> posts </h2>
          <PostsList
            posts={this.state.posts}
            activityFillters={postsFilters}
            onFilterClick={this.handlePostsFillters}
            postsSetter={this.postsSetter}
          />
        </div>
        }
      </div>
    )
  }
}
